import { Link } from "react-router-dom";
import { COMPANY, openCookieSettings } from "@/lib/legalVersion";

/**
 * Phase 19 → P.18 — small reusable footer used on /, /login, /signup, /terms,
 * /privacy, /cookies, /dpa, /imprint and inside the app shell.
 *
 * `tone` controls light/dark text — landing renders on dark primary, others
 * on background.
 *
 * P.18 additions: adds Cookies / DPA / Imprint links and a small
 * "Cookie settings" link that re-opens the consent banner via a custom event.
 */
export default function PublicFooter({ tone = "light", showCookieSettings = true }) {
  const cls = tone === "light"
    ? "text-primary-foreground/40 hover:text-primary-foreground"
    : "text-muted-foreground hover:text-accent";
  const sep = tone === "light" ? "text-primary-foreground/20" : "text-muted-foreground/30";
  return (
    <div className="space-y-2" data-testid="public-footer">
      <div className="flex items-center justify-center gap-3 flex-wrap text-[11px] mono uppercase tracking-[0.2em]"
           data-testid="public-footer-links">
        <Link to="/terms" className={cls} data-testid="public-footer-terms">Terms</Link>
        <span className={sep}>·</span>
        <Link to="/privacy" className={cls} data-testid="public-footer-privacy">Privacy</Link>
        <span className={sep}>·</span>
        <Link to="/cookies" className={cls} data-testid="public-footer-cookies">Cookies</Link>
        <span className={sep}>·</span>
        <Link to="/dpa" className={cls} data-testid="public-footer-dpa">DPA</Link>
        <span className={sep}>·</span>
        <Link to="/imprint" className={cls} data-testid="public-footer-imprint">Imprint</Link>
        <span className={sep}>·</span>
        <a href={`mailto:${COMPANY.contact_email}`} className={cls} data-testid="public-footer-contact">Contact</a>
        {showCookieSettings && (
          <>
            <span className={sep}>·</span>
            <button
              type="button"
              onClick={openCookieSettings}
              className={`${cls} bg-transparent border-0 p-0 cursor-pointer`}
              data-testid="public-footer-cookie-settings"
            >
              Cookie settings
            </button>
          </>
        )}
      </div>
      <div className={`text-center text-[10px] mono tracking-widest uppercase ${tone === "light" ? "text-primary-foreground/40" : "text-muted-foreground/70"}`}
           data-testid="public-footer-copyright">
        © {new Date().getFullYear()} {COMPANY.legal_name} · {COMPANY.address} · {COMPANY.contact_email}
      </div>
    </div>
  );
}
